import { useHistory } from 'react-router-dom';
import { useAppDispatch, useAppSelector } from '../../app/hooks';
import {
  avancarParaProximoIntegrante,
  limparIndicativoNascimento,
  selectEtapaIndicativo,
  selectTemProximoIntegrante,
} from './indicativoNascimentoSlice';
import AvisoIndicativoNascimento from './AvisoIndicativoNascimento/AvisoIndicativoNascimento';
import IndicativoNascimentoConfirmacao from './IndicativoNascimentoConfirmacao/IndicativoNascimentoConfirmacao';
import IndicativoNascimentoPerguntas from './IndicativoNascimentoPerguntas/IndicativoNascimentoPerguntas';
import IndicativoNascimentoResumo from './IndicativoNascimentoResumo/IndicativoNascimentoResumo';
import IndicativoNascimentoConclusao from './IndicativoNascimentoConclusao/IndicativoNascimentoConclusao';
import IndicativoNascimentoErro from './IndicativoNascimentoErro/IndicativoNascimentoErro';
import IndicativoNascimentoErroHorario from './IndicativoNascimentoErroHorario/IndicativoNascimentoErroHorario';
import IndicativoNascimentoErroServico from './IndicativoNascimentoErroServico/IndicativoNascimentoErroServico';
import ComparecaAoCras from './ComparecaAoCras/ComparecaAoCras';
import ComparecaAoCrasInclusao from './ComparecaAoCrasInclusao/ComparecaAoCrasInclusao';

const PainelIndicativoNascimento: React.FC = () => {
  const dispatch = useAppDispatch();
  const history = useHistory();
  const etapa = useAppSelector(selectEtapaIndicativo);

  const temProximo = useAppSelector(selectTemProximoIntegrante);

  const fechar = () => {
    if (temProximo) {
      dispatch(avancarParaProximoIntegrante());
    } else {
      dispatch(limparIndicativoNascimento());
      history.replace('/home');
    }
  };

  const renderEtapa = () => {
    switch (etapa) {
      case 'inicio':            return <AvisoIndicativoNascimento onFechar={fechar} />;
      case 'confirmacao':       return <IndicativoNascimentoConfirmacao />;
      case 'perguntas':         return <IndicativoNascimentoPerguntas />;
      case 'resumo':            return <IndicativoNascimentoResumo />;
      case 'compareca-ao-cras':         return <ComparecaAoCras onFechar={fechar} />;
      case 'compareca-ao-cras-inclusao': return <ComparecaAoCrasInclusao onFechar={fechar} />;
      case 'conclusao':         return <IndicativoNascimentoConclusao onFechar={fechar} />;
      case 'erro':               return <IndicativoNascimentoErro onFechar={fechar} />;
      case 'erro-horario':       return <IndicativoNascimentoErroHorario onFechar={fechar} />;
      case 'erro-servico':       return <IndicativoNascimentoErroServico onFechar={fechar} />;
      default:                  return <AvisoIndicativoNascimento onFechar={fechar} />;
    }
  };

  return <>{renderEtapa()}</>;
};

export default PainelIndicativoNascimento;
